import * as React from 'react'

import { Text } from '@doordash/design-language'

import { CityJobsContainer, CityTitle, Job } from './styles'

import * as GLOBAL_CONSTANT from '../../../constants'

type Props = {
  cityTitle: string
  slug: string
}

const DrivingOpportunitiesCityJobs: React.SFC<Props> = ({
  cityTitle,
  slug,
}) => (
  <CityJobsContainer>
    <CityTitle styles={Text.Styles.SectionTitle}>{cityTitle}</CityTitle>
    <Job
      tag={'a'}
      href={`${GLOBAL_CONSTANT.BASE_PATH}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_1}/`}
    >
      {GLOBAL_CONSTANT.JOB_1}
    </Job>

    <Job
      tag={'a'}
      href={`${GLOBAL_CONSTANT.BASE_PATH}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_2}/`}
    >
      {GLOBAL_CONSTANT.JOB_2}
    </Job>

    <Job
      tag={'a'}
      href={`${GLOBAL_CONSTANT.BASE_PATH}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_3}/`}
    >
      {GLOBAL_CONSTANT.JOB_3}
    </Job>

    <Job
      tag={'a'}
      href={`${GLOBAL_CONSTANT.BASE_PATH}/${slug}/${GLOBAL_CONSTANT.JOB_TYPE_4}/`}
    >
      {GLOBAL_CONSTANT.JOB_4}
    </Job>
  </CityJobsContainer>
)

export default DrivingOpportunitiesCityJobs
